'use client'

import { List, ListItem, ListItemText, styled } from '@mui/material'

export const StyledList = styled(List)(({ theme }) => ({
  marginTop: '26px',
  borderRadius: '2px',
  border: `1px solid ${theme.palette.border.default}`,
  padding: '16px',
  [theme.breakpoints.up('md')]: {
    padding: '32px',
  },
}))
export const StyledListitem = styled(ListItem)(({ theme }) => ({
  padding: 0,
  paddingBottom: 14,
  [theme.breakpoints.up('md')]: {
    paddingBottom: 16,
  },
  '&:last-child': { paddingBottom: 0 },
}))
export const ListitemSeparator = styled(ListItem)(() => ({ padding: 8 }))
export const StyledListItemText = styled(ListItemText)(({ theme }) => ({
  margin: 0,
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
  },
  '& .MuiListItemText-primary, & .MuiListItemText-secondary': {
    color: theme.palette.text.primary,
    display: 'inline-block',
    marginRight: theme.spacing(1),
    verticalAlign: 'text-top',
    fontSize: '16px',
  },
  '& .MuiListItemText-primary': {
    fontWeight: '700',
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '50%',
      minWidth: '50%',
    },
  },
}))
